import TemplateView from '../../TemplateView'
import {PRIORITY_FIELD_NAME, TaskSortBy, TaskTableConfigurableColumns} from '../constants'
import SortableTableHeader from '../../controls/SortableTableHeader'
import $ from 'jquery'
import TaskSelectionLabel from '../TaskSelectionLabel'
import {changeTasksSortingAction, updateTaskTypeOfWork} from './actions'
import {getArchivedProjectIds, getIsSummaryRowShown, getShownColumnsWithOrder, getTasksSorting, thereAreTableTasks} from './selectors'
import {
    getEditableProjectIds,
    getEditableTaskIds,
    getSingleCPSelection,
    getTaskCustomFieldsMap,
    getViewerSettings,
    isNeedToShowSelection,
} from '../common/selectors'
import {connect} from "../../redux/utils"
import {bindActionCreators} from 'redux'
import {isBTYEnabled, isESTEnabled, isTWSEnabled} from '../../features/selectors'
import {isAllTasksSelectedCheckboxChecked} from '../taskSelection/selectors'
import SimpleTooltip from '../../SimpleTooltip'
import SummaryRow from './SummaryRow'
import ClassicBridge from '../../next/ClassicBridge'

class TaskTableHeader extends TemplateView {
    constructor({
        changeTasksSortingAction = () => {},
        updateTaskTypeOfWork = () => {},
    }) {
        super()

        this.actions = {
            changeTasksSortingAction,
            updateTaskTypeOfWork,
        }

        this.state = {
            isScrolling: false,
            isTWSEnabled: null,
            isBTYEnabled: null,
            isESTEnabled: null,

            sorting: {
                by: '',
                asc: false,
            },

            showSelection: false,
            allTaskSelected: false,
            selectAllDisabled: false,
            isSummaryRowShown: false,

            columnsOrder: [],
            singleCustomerProjectSelection: {},

            customFields: {}
        }

        this.onStatePropertyChanged('singleCustomerProjectSelection', singleCustomerProjectSelection => {
            if (singleCustomerProjectSelection.customerId && !singleCustomerProjectSelection.projectId) {
                this._toggleCptSortButtons(false, true)
            } else if (singleCustomerProjectSelection.customerId && singleCustomerProjectSelection.projectId) {
                this._toggleCptSortButtons(false, false)
            } else {
                this._toggleCptSortButtons(true, true)
            }
        })

        this.onStatePropertyChanged('isScrolling', (isScrolling) => {
            this.$el.toggleClass('scrolling', isScrolling)
        })

        this.onStatePropertyChanged('sorting', (sorting) => {
            this.setSortHeader(sorting.by, sorting.asc)
        })

        this.onStatePropertyDeeplyChanged('customFields', (customFields) => {
            this._removeCustomFieldsColumns()
            this._renderCustomFieldsColumns(customFields)
            this._registerSortingHeaderCallbacks()
        })

        this.onStatePropertyChanged('columnsOrder', (columnsOrder) => {
            for (let column of Object.values(this.columnsMap)) {
                this.find(".prioritySeparator").hide()
                column.hide()
            }

            for (let i = 0; i < columnsOrder.length; ++i) {
                const columnKey = columnsOrder[i]
                if (!this.columnsMap[columnKey]) continue
                this.columnsMap[columnKey].show()
                if (columnKey === PRIORITY_FIELD_NAME) {
                    this.columnsMap[columnKey].show()
                    this.find(".prioritySeparator").show()
                } else {
                    this.columnsMap[columnKey].css('display', 'flex')
                }
                this.columnsMap[columnKey].css('order', i.toString())
            }
        })

        this.onStatePropertyChanged('isTWSEnabled', (isTWSEnabled) => {
            // rewrite click action on status header
            $(this.statusHeader).off('click')
            $(this.statusHeader).on('click', () => {
                this.actions.changeTasksSortingAction({
                    by: isTWSEnabled ? TaskSortBy.WORKFLOW_STATUS : TaskSortBy.STATUS,
                    asc: this.statusHeader.isAsc(),
                })
            })
        })

        this.onStatePropertyChanged('isBTYEnabled', (isBTYEnabled) => {
            this.typeOfWorkHeader.toggle(isBTYEnabled)
        })

        this.onStatePropertyChanged('isESTEnabled', (isESTEnabled) => {
            this.estimateHeader.toggle(isESTEnabled)
            this.varianceManHoursHeader.toggle(isESTEnabled)
            this.variancePercentHeader.toggle(isESTEnabled)
            this.varianceProgressBarHeader.toggle(isESTEnabled)
        })

        this.onAnyStatePropertyChanged(['allTaskSelected', 'showSelection', 'selectAllDisabled'], () => {
            this._updateAllTasksSelection()
        })

        this.onStatePropertyChanged('isSummaryRowShown', (isSummaryRowShown) => {
            this.summaryRow.toggle(isSummaryRowShown)
        })
    }

    templateHtml() {
        return "<table class='headerRowTable' cellpadding='0' cellspacing='0'>" +
               "  <tr class='headers'>" +
               "    <td class='selection'></td>" +
               "    <td class='names'>" +
               "      <div class='headerCellWrapper'>" +
               "        <div class='tipPlaceholderContainer'><span class='tipPlaceholder'></span></div>" +
               "        <span class='priorityHeader'><span class='customFieldHeader' /></span>" +
               "        <span class='shortSeparator prioritySeparator'>&nbsp;</span>" +
               "        <span class='customerNameHeader'></span>" +
               "        <span class='shortSeparator customerNameSeparator'>&nbsp;</span>" +
               "        <span class='projectNameHeader'></span>" +
               "        <span class='shortSeparator projectNameSeparator'>&nbsp;</span>" +
               "        <span class='taskNameHeader'></span>" +
               "      </div>" +
               "    </td>" +
               "    <td class='status'>" +
               "      <div class='headerCellWrapper'>" +
               "        <span class='statusHeader'></span>" +
               "      </div>" +
               "    </td>" +
               "    <td class='typeOfWork'>" +
               "      <div class='headerCellWrapper'><span class='typeOfWorkHeader'></span></div>" +
               "    </td>" +
               "    <td class='estimate'>" +
               "      <div class='headerCellWrapper'><span class='estimateHeader'></span></div>" +
               "    </td>" +
               "    <td class='spentTime'>" +
               "      <div class='headerCellWrapper'><span class='spentTimeHeader'></span></div>" +
               "    </td>" +
               "    <td class='deadline'>" +
               "      <div class='headerCellWrapper'><span class='deadlineHeader'></span></div>" +
               "    </td>" +
               "    <td class='lastTrackingDate'>" +
               "      <div class='headerCellWrapper'><span class='lastTrackingDateHeader'></span></div>" +
               "    </td>" +
               "    <td class='creationDate'>" +
               "      <div class='headerCellWrapper'><span class='creationDateHeader'></span></div>" +
               "    </td>" +
               "    <td class='varianceManHours'>" +
               "      <div class='headerCellWrapper'><span class='varianceManHoursHeader'></span></div>" +
               "    </td>" +
               "    <td class='variancePercent'>" +
               "      <div class='headerCellWrapper'><span class='variancePercentHeader'></span></div>" +
               "    </td>" +
               "    <td class='varianceProgressBar'>" +
               "      <div class='headerCellWrapper'><span class='varianceProgressBarHeader'></span></div>" +
               "    </td>" +
               "  </tr>" +
               "</table>"
    }

    afterRender() {
        this.$allTaskSelection = this.find(".selection")
        this.tooltip = new SimpleTooltip().init($('body'))

        this.sortingHeaders = {}
        // Persistence block
        this.customerNameHeader = new SortableTableHeader(this.find(".customerNameHeader"), false, true, "common.Customer").init()
        this.customerNameSeparator = this.find(".customerNameSeparator")
        this.sortingHeaders[TaskSortBy.CUSTOMER] = this.customerNameHeader

        this.projectNameHeader = new SortableTableHeader(this.find(".projectNameHeader"), false, true, "common.Project").init()
        this.projectNameSeparator = this.find(".projectNameSeparator")
        this.sortingHeaders[TaskSortBy.PROJECT] = this.projectNameHeader

        this.taskNameHeader = new SortableTableHeader(this.find(".taskNameHeader"), false, true, "common.Task").init()
        this.sortingHeaders[TaskSortBy.TASK] = this.taskNameHeader

        // this header sorting depends from feature
        this.statusHeader = new SortableTableHeader(this.find(".statusHeader"), false, true, "task.list.status").init()
        this.sortingHeaders[TaskSortBy.STATUS] = this.statusHeader
        this.sortingHeaders[TaskSortBy.WORKFLOW_STATUS] = this.statusHeader

        this.typeOfWorkHeader = new SortableTableHeader(this.find(" .typeOfWorkHeader"), false, true, "task.list.type_of_work").init()
        this.sortingHeaders[TaskSortBy.TYPE_OF_WORK] = this.typeOfWorkHeader

        this.estimateHeader = new SortableTableHeader(this.find(".estimateHeader"), false, true, "task.list.estimate").init()
        this.sortingHeaders[TaskSortBy.ESTIMATE] = this.estimateHeader

        this.deadlineHeader = new SortableTableHeader(this.find(".deadlineHeader"), false, true, "task.list.deadline").init()
        this.sortingHeaders[TaskSortBy.DEADLINE] = this.deadlineHeader

        this.spentTimeHeader = new SortableTableHeader(this.find(".spentTimeHeader"), false, true, "task.list.spent_time").init()
        this.sortingHeaders[TaskSortBy.SPENT_TIME] = this.spentTimeHeader

        this.lastTrackingDateHeader = new SortableTableHeader(this.find(".lastTrackingDateHeader"), false, true, "task.list.last_tracking_date").init()
        this.sortingHeaders[TaskSortBy.LAST_TRACKING_DATE] = this.lastTrackingDateHeader

        this.creationDateHeader = new SortableTableHeader(this.find(".creationDateHeader"), false, true, "task.list.creation_date").init()
        this.sortingHeaders[TaskSortBy.CREATION_DATE] = this.creationDateHeader

        this.varianceManHoursHeader = new SortableTableHeader(this.find(".varianceManHoursHeader"), false, true, "task.list.variance_man_hours").init()
        this.sortingHeaders[TaskSortBy.VARIANCE_MAN_HOURS] = this.varianceManHoursHeader
        this.tooltip.subscribeToMouseEvents(
            this.find(".varianceManHoursHeader"),
            () => this.tooltip.setText(messageResource.getMessage("task.list.variance_man_hours.tooltip"))
        )

        this.variancePercentHeader = new SortableTableHeader(this.find(".variancePercentHeader"), false, true, "task.list.variance_percents").init()
        this.sortingHeaders[TaskSortBy.VARIANCE_PERCENTS] = this.variancePercentHeader
        this.tooltip.subscribeToMouseEvents(
            this.find(".variancePercentHeader"),
            () => this.tooltip.setText(messageResource.getMessage("task.list.variance_percents.tooltip"))
        )

        this.varianceProgressBarHeader = new SortableTableHeader(this.find(".varianceProgressBarHeader"), false, true, "task.list.variance_progress_bar").init()
        this.sortingHeaders[TaskSortBy.VARIANCE_PROGRESS_BAR] = this.varianceProgressBarHeader

        this.summaryRow = new SummaryRow().init(this.find("tbody"))
        this.summaryRow.hide()

        this.columnsMap = {
            [TaskTableConfigurableColumns.ESTIMATE]: this.find("td.estimate"),
            [TaskTableConfigurableColumns.DEADLINE]: this.find("td.deadline"),
            [TaskTableConfigurableColumns.CREATION_DATE]: this.find("td.creationDate"),
            [TaskTableConfigurableColumns.LAST_TRACKING_DATE]: this.find("td.lastTrackingDate"),
            [TaskTableConfigurableColumns.SPENT_TIME]: this.find("td.spentTime"),
            [TaskTableConfigurableColumns.TYPE_OF_WORK]: this.find("td.typeOfWork"),
            [TaskTableConfigurableColumns.VARIANCE_MAN_HOURS]: this.find("td.varianceManHours"),
            [TaskTableConfigurableColumns.VARIANCE_PERCENTS]: this.find("td.variancePercent"),
            [TaskTableConfigurableColumns.VARIANCE_PROGRESS_BAR]: this.find("td.varianceProgressBar"),
        }

        this._registerSortingHeaderCallbacks()
    }

    setSortHeader(by, asc) {
        const byWorkflowStatus = by === TaskSortBy.WORKFLOW_STATUS
        for (let key of Object.keys(this.sortingHeaders)) {
            let sortingHeader = this.sortingHeaders[key]
            if (byWorkflowStatus && key !== TaskSortBy.STATUS
                || !byWorkflowStatus && key === TaskSortBy.STATUS
                || key !== TaskSortBy.STATUS && key !== TaskSortBy.WORKFLOW_STATUS
            ) {
                if (key === by) {
                    sortingHeader.setActive(true)
                    sortingHeader.setAsc(asc)
                } else {
                    sortingHeader.setActive(false)
                }
            }
        }
    }

    _toggleCptSortButtons(showCustomer, showProject) {
        this.customerNameHeader.toggle(showCustomer)
        this.customerNameSeparator.toggle(showCustomer)
        this.projectNameHeader.toggle(showProject)
        this.projectNameSeparator.toggle(showProject)

        if (!showCustomer && this.state.sorting.by === TaskSortBy.CUSTOMER) {
            if (showProject) {
                this.setSortHeader(TaskSortBy.PROJECT, this.state.sorting.asc)
            } else {
                this.setSortHeader(TaskSortBy.TASK, this.state.sorting.asc)
            }
        } else if (!showProject && this.state.sorting.by === TaskSortBy.PROJECT) {
            this.setSortHeader(TaskSortBy.TASK, this.state.sorting.asc)
        } else {
            this.setSortHeader(this.state.sorting.by, this.state.sorting.asc)
        }
    }

    _updateAllTasksSelection() {
        this.$allTaskSelection.empty()
        if (this.state.showSelection) {
            this.$allTaskSelection.show()
            this.allTaskSelectionLabel = new TaskSelectionLabel(this.$allTaskSelection, true).init()
            this.allTaskSelectionLabel.setSelection(this.state.allTaskSelected)
            this.allTaskSelectionLabel.setDisabled(this.state.selectAllDisabled)
            this.allTaskSelectionLabel.on("change", (e, isAllSelected) => {
                // this.actions.changeSelectAllTasks(isAllSelected)

                $(document).trigger("taskManagement_taskTable_selectAllChange", isAllSelected)
            })
        } else {
            this.$allTaskSelection.hide()
        }
    }

    _removeCustomFieldsColumns() {
        Object.keys(this.columnsMap)
              .filter(column => ClassicBridge.isCustomField(column))
              .forEach(cf => {
                  this.columnsMap[cf].remove()
                  delete this.columnsMap[cf]
              })
    }

    _renderCustomFieldsColumns(customFields) {
        const $headerRow = this.find('.headers')
        Object.values(customFields).forEach((customField) => {
            const tableCell = customField.fieldName === PRIORITY_FIELD_NAME
                ? this.find(".priorityHeader")
                : $(
                    "<td class='customField'>" +
                    "   <div class='headerCellWrapper'>" +
                    "       <span class='customFieldHeader'>" +
                    "       </span>" +
                    "   </div>" +
                    "</td>"
                ).appendTo($headerRow)
            this.columnsMap[customField.fieldName] = tableCell
            tableCell.attr('title', customField.title)

            this.sortingHeaders[customField.fieldName] = new SortableTableHeader(
                tableCell.find(".customFieldHeader"), false, true, null, customField.title
            ).init()
        })
    }

    _registerSortingHeaderCallbacks() {
        for (let sortingHeaderKey of Object.keys(this.sortingHeaders)) {
            let sortingHeader = this.sortingHeaders[sortingHeaderKey]
            $(sortingHeader).off('click')
            $(sortingHeader).on('click', () => {
                this.actions.changeTasksSortingAction({
                    by: sortingHeaderKey,
                    asc: sortingHeader.isAsc(),
                })
            })
        }
    }
}

export default connect(
    (state) => ({
        sorting: getTasksSorting(state),
        archivedProjectIds: getArchivedProjectIds(state),
        viewerSettings: getViewerSettings(state),
        editableTaskIds: getEditableTaskIds(state),
        editableProjectIds: getEditableProjectIds(state),
        showSelection: isNeedToShowSelection(state),
        isTWSEnabled: isTWSEnabled(state),
        isBTYEnabled: isBTYEnabled(state),
        isESTEnabled: isESTEnabled(state),
        columnsOrder: getShownColumnsWithOrder(state),
        singleCustomerProjectSelection: getSingleCPSelection(state),
        allTaskSelected: isAllTasksSelectedCheckboxChecked(state),
        selectAllDisabled: !thereAreTableTasks(state),
        customFields: getTaskCustomFieldsMap(state),
        isSummaryRowShown: getIsSummaryRowShown(state)
    }),
    (dispatch) => ({
        changeTasksSortingAction: bindActionCreators(changeTasksSortingAction, dispatch),
        updateTaskTypeOfWork: bindActionCreators(updateTaskTypeOfWork, dispatch),
    })
)(TaskTableHeader)



// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/TaskTableHeader.js